import { createContext, useState } from "react";
import * as uuid from "uuid";

const RecipeContext = createContext({
  name: "",
  ingredients: [],
  miseEnPlace: [],
  method: [],
  notes: [],
  missingParts: false,
  updateMissingParts: (value) => {},
  updateName: (name) => {},
  addIngredient: (ingredient) => {},
  removeIngredient: (ingredientKey) => {},
  removeAll: () => {},
  moveIngredient: (ingredients) => {},
  addMiseEnPlace: (miseEnPlace) => {},
  removeMiseEnPlace: (miseEnPlaceKey) => {},
  moveMiseEnPlace: (miseEnPlaces) => {},
  addMethod: (method) => {},
  removeMethod: (methodKey) => {},
  moveMethod: (methods) => {},
  addNote: (note) => {},
  removeNote: (noteKey) => {},
  moveNote: (notes) => {},
});

export function RecipeContextProvider(props) {
  const [name, setName] = useState("");

  function upateName(name) {
    setName(name);
  }

  const [ingredients, setIngredients] = useState([
    {
      key: uuid.v4(),
      amount: "",
      unit: "x",
      name: "",
      order: 0,
    },
  ]);

  function addIngredient(ingredient) {
    setIngredients((prevIngredient) => {
      return prevIngredient.concat({
        key: uuid.v4(),
        amount: ingredient.amount,
        unit: ingredient.unit,
        name: ingredient.name,
        order: ingredients.length,
      });
    });
  }

  function removeIngredient(ingredientKey) {
    if (context.ingredients.length > 1) {
      setIngredients((prevIngredient) => {
        return prevIngredient.filter(
          (ingredient) => ingredient.key !== ingredientKey
        );
      });
    }
  }

  function removeAll() {
    upateName("");
    setIngredients([]);
    setMiseEnPlace([]);
    setMethod([]);
    setNotes([]);
  }

  function moveIngredient(ingredients) {
    setIngredients(ingredients);
  }

  const [miseEnPlace, setMiseEnPlace] = useState([]);

  function addMiseEnPlace(miseEnPlace) {
    setMiseEnPlace((prevMiseEnPlace) => {
      return prevMiseEnPlace.concat({
        key: uuid.v4(),
        item: miseEnPlace,
      });
    });
  }

  function removeMiseEnPlace(miseEnPlaceKey) {
    setMiseEnPlace((prevMiseEnPlace) => {
      return prevMiseEnPlace.filter(
        (miseEnPlace) => miseEnPlace.key !== miseEnPlaceKey
      );
    });
  }

  function moveMiseEnPlace(miseEnPlace) {
    setMiseEnPlace(miseEnPlace);
  }

  const [method, setMethod] = useState([]);

  function addMethod(method) {
    setMethod((prevMethod) => {
      return prevMethod.concat({
        key: uuid.v4(),
        item: method,
      });
    });
  }

  function removeMethod(methodKey) {
    setMethod((prevMethod) => {
      return prevMethod.filter((method) => method.key !== methodKey);
    });
  }

  function moveMethod(method) {
    setMethod(method);
  }

  const [notes, setNotes] = useState([]);

  function addNote(note) {
    setNotes((prevNotes) => {
      return prevNotes.concat({
        key: uuid.v4(),
        item: note,
      });
    });
  }

  function removeNote(noteKey) {
    setNotes((prevNotes) => {
      return prevNotes.filter((notes) => notes.key !== noteKey);
    });
  }

  function moveNote(notes) {
    setNotes(notes);
  }

  const [missingParts, setMissingParts] = useState(false);

  function updateMissingParts(value) {
    var regExp = /([A-Za-z0-9 ])/g;
    setMissingParts(!regExp.test(value));
  }

  const context = {
    name: name,
    ingredients: ingredients,
    miseEnPlace: miseEnPlace,
    method: method,
    notes: notes,
    missingParts: missingParts,
    updateMissingParts: updateMissingParts,
    updateName: upateName,
    addIngredient: addIngredient,
    removeIngredient: removeIngredient,
    removeAll: removeAll,
    moveIngredient: moveIngredient,
    addMiseEnPlace: addMiseEnPlace,
    removeMiseEnPlace: removeMiseEnPlace,
    moveMiseEnPlace: moveMiseEnPlace,
    addMethod: addMethod,
    removeMethod: removeMethod,
    moveMethod: moveMethod,
    addNote: addNote,
    removeNote: removeNote,
    moveNote: moveNote,
  };

  return (
    <RecipeContext.Provider value={context}>
      {props.children}
    </RecipeContext.Provider>
  );
}

export default RecipeContext;
